// ============================================================
// Live clock store - actualiza cada 1s con la hora actual.
// Se renderiza en el topbar para que el operador vea "trading time"
// sin necesidad de mirar el reloj del SO.
// ============================================================

import { onDestroy } from 'svelte';

interface ClockState {
  now: Date;
}

export const clock = $state<ClockState>({ now: new Date() });

let intervalId: ReturnType<typeof setInterval> | null = null;

function tick(): void {
  clock.now = new Date();
}

// Auto-arranca al primer import. Si nadie lo consume, no pasa nada;
// es solo 1 setInterval cada 1s, costo despreciable.
if (typeof window !== 'undefined' && !intervalId) {
  tick();
  intervalId = setInterval(tick, 1000);
}

export function stopClock(): void {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}

/**
 * Hook para Svelte components: garantiza cleanup si el componente
 * se desmonta. No es estrictamente necesario porque el clock es
 * global, pero protege en SSR/tests.
 */
export function useClock(): void {
  onDestroy(() => {
    // No cleanup; el clock sigue vivo para otros consumers.
  });
}

export function fmtTimeOfDay(d: Date): string {
  return d.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}
